/* global svg4everybody */

export default function init() {
  svg4everybody({
    // nosvg: true,
    // polyfill: true,
    fallback(src/* , svg, use */) {
      const name = src.split('#')[1];
      const path = `/${src.split('/').slice(1, 5).join('/')}/img/${name}.png`;

      // src: current xlink:href String
      // svg: current SVG Element
      // use: current USE Element
      return path;
    },
  });
}



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/svgIcons.js